import React from 'react';
import { Box, Paper, Skeleton } from '@mui/material';

export const CreditPackSkeleton: React.FC = () => (
  <Paper sx={{ p: 4, textAlign: 'center', height: '100%', border: 2, borderColor: 'divider' }}>
    <Skeleton variant="circular" width={40} height={40} sx={{ mx: 'auto', mb: 1 }} />
    <Skeleton variant="text" width="60%" sx={{ mx: 'auto', fontSize: '2rem' }} />
    <Skeleton variant="text" width="80%" sx={{ mx: 'auto' }} />
    <Skeleton variant="text" width="50%" sx={{ mx: 'auto', mb: 3 }} />
    <Box sx={{ textAlign: 'left', mb: 3 }}>
      {[1, 2, 3, 4].map((i) => (
        <Skeleton key={i} variant="text" width="90%" sx={{ mb: 1 }} />
      ))}
    </Box>
    <Skeleton variant="rectangular" height={36} />
  </Paper>
);
